export default "__VITE_ASSET__BQTftY3V__"